import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
export default forwardRef((props, ref) => jsx("svg", {
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 -0.5 21 21",
    ref,
    ...props,
    dangerouslySetInnerHTML: { __html: '<path d="M5.817 12.708A1.458 1.458 0 0 1 4.36 11.25V5.625c0-.92.746-1.667 1.666-1.667h5.625c.806 0 1.459.653 1.459 1.459" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" /> <path d="M14.775 7.292H9.36c-.92 0-1.667.746-1.667 1.666v5.417c0 .92.746 1.667 1.667 1.667h5.416c.92 0 1.667-.747 1.667-1.667V8.958c0-.92-.746-1.666-1.667-1.666Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />' }
  })
);